import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { AccountListProvider } from '../context/AccountListContext';
import GlobalAccountWrapper from '../components/Frontend/GlobalAccounts/GlobalAccountWrapper';

export const globalAccountsRoutes = (
  <Route path="/global_accounts" element={<MainLayout />}>
    <Route path="" element={
      <AccountListProvider> <GlobalAccountWrapper /></AccountListProvider>} />
  </Route>
);
